<div class="wrapper wrapper-content" *ngIf="isLoaded()">
  <div class="container-fluid p-0">
    <div class="row p-0">
      <div class="col-12">
        <p-panel styleClass="mb-3" [toggleable]="true">
          <p-header>
            <i class="fa fa-filter" aria-hidden="true"></i> {{ 'Filtros' | translate }}
          </p-header>
          <div class="row">
            <div class="col-12 m-b-md">
              <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
              </formPlyca>
            </div>
          </div>
        </p-panel>

        <p-panel styleClass="mb-3" [toggleable]="true"
        [collapsed]="(!model || !(model.dynamicPurchasingSystem) ||!(model.dynamicPurchasingSystem.identifier))">
        <p-header>
          <!--<i class="fa fas fa-lg fa-file-contract"></i> -->
          <span class="cif ml-2">Datos del sistema dinámico de adquisición</span>
        </p-header>
        <ng-container *ngIf="model && model.dynamicPurchasingSystem && model.dynamicPurchasingSystem.identifier">
          <ng-container *ngTemplateOutlet="dynamicPurchasingSystemBasicInfo; context: { model: model }">
          </ng-container>
        </ng-container>
        <p-tabView>
          <p-tabPanel cache="false" header="{{'Categorías / CPVs del SDA' | translate}}">
            <div>
              <p-table
                *ngIf="model.filterCategoryCPVsSDAList && model.filterCategoryCPVsSDAList.length>0"
                [responsive]="true"
                [value]="model.filterCategoryCPVsSDAList" sortOrder="1" [paginator]="false">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 10%">{{'Categoría'|translate}}</th>
                    <th style="width: 70%">{{'CPV'|translate}}</th>
                    <th style="width: 10%">{{'Fecha de vigencia'|translate}}</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-element let-idx="rowIndex">
                  <tr>
                    <td><span
                        class="p-column-title">{{'Categoría'|translate}}</span>{{element.categoryLabel}}
                    </td>
                    <td><span
                        class="p-column-title">{{'CPV'|translate}}</span>{{element.cpvLabel}}
                    </td>
                    <td><span
                        class="p-column-title">{{'Fecha de vigencia'|translate}}</span>{{element.validDate |date: 'dd/MM/yyyy'}}
                    </td>
                    <td class="text-right">
                      <div class="btn-group">
                        <button [attr.disabled]="(!element.newspecificContractEnabled)?'disabled':undefined"
                          class="btn btn-outline-secondary btn-sm t-action-button"
                          (click)="this.createspecificContract(element)"
                          title="{{ 'Iniciar Contrato Especifico' | translate}}">
                          <i class="fas fa-plus" aria-hidden="true"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-tabPanel>
          <p-tabPanel cache="false" header="{{'Contratos Específicos' | translate}}">
            <div>
              <div class="alert alert-info col-12" role="alert"
                *ngIf="!model.filterCSDAList || model.filterCSDAList.length===0">
                <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
                  'General.noData' | translate }}</span>
              </div>
              <p-table *ngIf="model.filterCSDAList && model.filterCSDAList.length>0"
                [value]="model.filterCSDAList" sortField="columns['CONTRATOID']?.value" sortOrder="1"
                [rows]="10" [paginator]="true" [pageLinks]="4" [rowsPerPageOptions]="[5, 10, 25, 50]">

                <ng-template pTemplate="header">
                  <tr>
                    <th></th>
                    <th>{{'Número de Contrato'|translate}}</th>
                    <th>{{'Título Abreviado'|translate}}</th>
                    <th>{{'Categoría'|translate}}</th>
                    <th>{{'CPV'|translate}}</th>
                    <th>{{'Presup B. Lic'|translate}}</th>
                    <th>{{'Adjudicatario'|translate}}</th>
                    <th>{{'Fecha de Adjudicación'|translate}}</th>
                    <th>{{'Precio'|translate}}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-element let-idx="rowIndex">
                  <tr>
                    <td>
                      {{idx+1}}
                    </td>
                    <td>{{element.columns['NUMREGCON_CSDA']?.value}}
                    </td>
                    <td>{{element.columns['TIT_ABREVIADO_CSDA']?.value}}
                    </td>
                    <td>{{element.columns['CATEGORIA_NUM_CSDA']?.value}}
                    </td>
                    <td>{{element.columns['CPVDESC_CSDA']?.value}}
                    </td>
                    <td style="text-align: right;width: 120px ">{{element.columns['PRESUP']?.value
                      | currency: 'EUR' }}&nbsp;&nbsp;
                    </td>
                    <td>{{element.columns['ADJUDICATARIO_CSDA']?.value}}
                    </td>
                    <td>{{element.columns['FECHA_ADJ']?.value}}</td>
                    <td style="text-align: right;width: 120px ">{{element.columns['PRECIO']?.value
                      | currency: 'EUR' }}&nbsp;&nbsp;
                    </td>
                    <td class="text-right">
                      <div class="btn-group">
                        <pmenu-actions [identifier]="deNormalizaDossierId(element.columns['PROPUESTA_CSDA']?.value)"
                          [dto]="dossier" [lazy]="true" [dtoType]="PROJECTENTITY"
                          [items]="this.getDossierMenuItemCBAM(element.columns['PROPUESTA_CSDA']?.value)">
                        </pmenu-actions>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-tabPanel>
        </p-tabView>
      </p-panel>

      </div>
    </div>
  </div>
</div>

<!-- TEMPLATE PARA LOS DATOS BASICOS DEL CONTRATO -->
<ng-template #dynamicPurchasingSystemBasicInfo let-model="model">
  <h2 class="mt-1"></h2>
  <div class="row mt-1">

    <dl class="col-12">


      <dt class="d-inline-block col-12 col-md-3">{{'Sistema Dinámico de Adquisición'| translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span> {{model?.dynamicPurchasingSystem?.contractFolderId}}
        </span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Propuesta'| translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span>{{model?.dossierId}}</span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Título Abreviado' | translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span>{{model?.dynamicPurchasingSystem?.abbreviatedTitle}}</span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Valor Estimado' | translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
        <span>{{model?.dynamicPurchasingSystem?.budget?.estimatedAmount | currency: 'EUR' }}</span>
      </dd>

      <dt class="d-inline-block col-12 col-md-3">{{'Gasto Acumulado de Contratos Específicos Adjudicados'|translate}}:</dt>
      <dd class="d-inline-block col-12 col-md-3">
         <span>{{model?.csdaAccumulatedExpense | currency: 'EUR'}}</span>
      </dd>


      <div class="col-12 text-right">

        <!--<pmenu-actions [identifier]="model?.dossierId" [dto]="dossier" [lazy]="true" [dtoType]="PROJECTENTITY"
          [items]="this.getDossierMenuItemAM(model?.dossierId)">
        </pmenu-actions>-->
      </div>
    </dl>

  </div>
</ng-template>